import { render, staticRenderFns } from "./Quest.vue?vue&type=template&id=cbb5e1d8&scoped=true&"
import script from "./Quest.vue?vue&type=script&lang=js&"
export * from "./Quest.vue?vue&type=script&lang=js&"
import style0 from "./Quest.vue?vue&type=style&index=0&id=cbb5e1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb5e1d8",
  null
  
)

export default component.exports